export default "__VITE_ASSET__Bqx_0uW4__"